var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWppButton = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_90_989)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "#25D366"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3367 20.6561C45.8624 19.1744 44.1064 17.9996 42.1711 17.2002C40.2357 16.4008 38.1598 15.9928 36.0643 16.0001C27.2844 16.0001 20.1286 23.1201 20.1286 31.856C20.1286 34.656 20.8683 37.376 22.2513 39.776L20 48L28.4422 45.792C30.7739 47.056 33.395 47.728 36.0643 47.728C44.8442 47.728 52 40.608 52 31.872C52 27.6321 50.3437 23.6481 47.3367 20.6561ZM36.0643 45.04C33.6844 45.04 31.3528 44.4 29.3106 43.2L28.8281 42.912L23.8111 44.224L25.1457 39.36L24.8241 38.864C23.5019 36.7632 22.7998 34.3348 22.798 31.856C22.798 24.5921 28.7477 18.6721 36.0482 18.6721C39.5859 18.6721 42.9146 20.0481 45.407 22.5441C46.6412 23.7664 47.6192 25.2203 48.2845 26.8215C48.9497 28.4228 49.2889 30.1394 49.2824 31.872C49.3146 39.136 43.3648 45.04 36.0643 45.04ZM43.3327 35.184C42.9307 34.992 40.9688 34.032 40.6151 33.888C40.2452 33.76 39.9879 33.696 39.7146 34.08C39.4412 34.48 38.6854 35.376 38.4603 35.632C38.2352 35.904 37.994 35.936 37.592 35.728C37.1899 35.536 35.9035 35.104 34.392 33.76C33.202 32.704 32.4141 31.408 32.1729 31.008C31.9477 30.6081 32.1407 30.4001 32.3497 30.1921C32.5266 30.0161 32.7518 29.7281 32.9447 29.5041C33.1377 29.2801 33.2181 29.1041 33.3467 28.8481C33.4754 28.5761 33.4111 28.3521 33.3146 28.1601C33.2181 27.9681 32.4141 26.0161 32.0925 25.2161C31.7709 24.4481 31.4332 24.5441 31.192 24.5281H30.4201C30.1467 24.5281 29.7286 24.6241 29.3588 25.0241C29.005 25.4241 27.9759 26.3841 27.9759 28.3361C27.9759 30.2881 29.407 32.176 29.6 32.432C29.793 32.704 32.4141 36.704 36.402 38.416C37.3508 38.832 38.0905 39.072 38.6693 39.248C39.6181 39.552 40.4864 39.504 41.1779 39.408C41.9497 39.296 43.5417 38.448 43.8633 37.52C44.201 36.592 44.201 35.808 44.0884 35.632C43.9759 35.456 43.7347 35.376 43.3327 35.184Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_989",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_989",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWppButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wpp-button.867d579da783daf15cf1c0bd043dd763.svg";